var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTiktok = function SvgTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 50 50"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    x: 0.5,
    y: 0.5,
    stroke: "#fff",
    rx: 24.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29.594 13.019c0 .365.108 5.658 5.663 5.986v4.087c-.422.024-3.657-.21-5.668-2.006l-.004 7.96c.075 5.521-3.99 8.882-9.3 7.724-9.17-2.742-6.122-16.33 3.075-14.873 0 4.387.004 0 .004 4.387-3.801-.557-5.072 2.602-4.064 4.866.919 2.063 4.702 2.508 6.024-.398.15-.568.225-1.22.225-1.946V13z"
  })));
};
export default SvgTiktok;